module.exports = __webpack_public_path__ + "img/logo.6b5bebc8.png";